import './tab_view.js.coffee'
Namespace 'Customer.Tabs'

class Customer.Tabs.TicketDetailsTabView extends Customer.Tabs.TabView
  template: JST["backbone/templates/customer/tabs/ticket_details_tab"]

  events:
    'click .tab': 'onClickTab'
    'click .fa-close': 'onClickClose'
    'click .fa-refresh': 'onClickUpdate'

  templateOptions: ->
    templateOpts = super
    templateOpts.hideRefresh = @options.hide_refresh || false
    templateOpts

  select: ->
    @tabbableView.startFetchingUpdates()
    super

  deselect: ->
    @tabbableView.stopFetchingUpdates()
    super

  onClickClose: =>
    @_keepCustomerSessionAlive()
    @tabbableView.stopFetchingUpdates()
    super

  startTabRefresh: () ->
    @$el.find('.fa.fa-refresh').addClass('fa-spin').parent().addClass('reloading')

  finishTabRefresh: () ->
    @$el.find('.fa.fa-refresh').removeClass('fa-spin').parent().removeClass('reloading')

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
